export default {
  init() {
    // JavaScript to be fired on the home page


// Get the value of the 'S' query parameter
//     const sValue = new URLSearchParams(location.search).get('s');
// // Update the current URL with the new string
//     window.location.hash = `#gsc.tab=0&gsc.q=${sValue}`;

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/searchResults.js